import 'css-chunksrc/client/scenes/projectResourceRemoval/list/styles.scss';export default {
  "list": "_list_1m7ho_1",
  "main": "_main_1m7ho_5",
  "header": "_header_1m7ho_10",
  "iconBox": "_iconBox_1m7ho_22",
  "icon": "_icon_1m7ho_22",
  "openedIcon": "_openedIcon_1m7ho_39",
  "row": "_row_1m7ho_43",
  "avatar": "_avatar_1m7ho_50",
  "col": "_col_1m7ho_55",
  "name": "_name_1m7ho_64",
  "profession": "_profession_1m7ho_73",
  "selected": "_selected_1m7ho_78"
};